<div class="block-fantazia">
    @if (link_now) {
        {{ 'links.txtContent' | translate }} <a class="link-registration" [href]="nowLinkSignUp()" target="_blank" rel="noopener noreferrer">{{ 'links.txtRegister' | translate }}</a>
    }
</div>
